import React from "react";
import { Link } from "react-router-dom";

const Header = () => {
  return (
    <div className="header-fixed flex space-between">
      <Link to="" className="logo-link">
        <img
          className="logo-img"
          alt="logo"
          src="/assets/HeliTaxii-logo.png"
        />
      </Link>
      <a href="https://thumbyaviation.com" target="_blank" rel="noopener noreferrer" className="logo-link">
        <img
          className="logo-img"
          alt="logo"
          src="/assets/thumby-logo.png"
        />
      </a>
    </div>
  );
};

export default Header;